module.exports = __webpack_public_path__ + "static/media/Group221.e3a8bd66.svg";